module.exports = __webpack_public_path__ + "static/img/image@1x-3.3242589.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/image@1x-3.png
// module id = kyoI
// module chunks = 0